module.exports = __webpack_public_path__ + "media/newstyle/images/icon-upload-white-f08866520dfa8eced72b516e4c0fef41.svg";